import { CustomEventWithDetail, html, type Html, View } from 'rune-ts';
import klass from './ArrowView.module.scss';
import { Title } from '../../../../atoms/Title/Title';
import {
  ChevronLeftIcon,
  ChevronRightIcon,
} from '../../../../../../shared/components/atoms/Icon/foundation_icons';

export type ArrowViewData = {
  // default xLarge
  size?: keyof typeof Title.sizeOptions;
  // default light
  theme?: keyof typeof Title.themeOptions;
  leftClickFn?: VoidFunction;
  rightClickFn?: VoidFunction;
};

export class LeftArrowClickEvent extends CustomEventWithDetail<{ direction: 'left' }> {}

export class RightArrowClickEvent extends CustomEventWithDetail<{ direction: 'right' }> {}

export class ArrowView extends View<ArrowViewData> {
  static readonly sizeOptions = {
    xLarge: {
      size_class: klass.xLarge,
    },
    large: {
      size_class: klass.large,
    },
    medium: {
      size_class: klass.medium,
    },
    small: {
      size_class: klass.small,
    },
    xSmall: {
      size_class: klass.xSmall,
    },
  } as const;

  static readonly themeOptions = {
    light: klass.light,
    dark: klass.dark,
  } as const;

  static RightArrowClickEvent = RightArrowClickEvent;
  static LeftArrowClickEvent = LeftArrowClickEvent;

  protected override template(): Html {
    const { size_class } = ArrowView.sizeOptions[this.size];
    const theme_class = ArrowView.themeOptions[this.theme];

    return html`
      <div class="${klass.container} ${theme_class} ${size_class}">
        <div class="${klass.left}">${ChevronLeftIcon()}</div>
        <div class="${klass.right}">${ChevronRightIcon()}</div>
      </div>
    `;
  }

  public get size() {
    return this.data.size || 'xLarge';
  }

  public get theme() {
    return this.data.theme || 'light';
  }

  protected override onRender() {
    const { rightClickFn, leftClickFn } = this.data;

    this.delegate('click', `.${klass.left}`, () => {
      this.dispatchEvent(ArrowView.LeftArrowClickEvent, { detail: { direction: 'left' }, bubbles: true });

      if (leftClickFn) {
        leftClickFn();
      }
    });

    this.delegate('click', `.${klass.right}`, () => {
      this.dispatchEvent(ArrowView.RightArrowClickEvent, { detail: { direction: 'right' }, bubbles: true });

      if (rightClickFn) {
        rightClickFn();
      }
    });
  }
}
